import { useTranslation } from "react-i18next";
import { Megaphone, Lock } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";

// زر إعلان الجاهزية: يُعطَّل قبل يوم الصرف (ما لم يُسمح بالإعلان المبكّر) مع نص متى يُفعَّل.
export const AnnounceControl = ({ cycle, busy, onAnnounce }) => {
  const { t } = useTranslation();
  const locked = cycle.open === false;
  return (
    <div>
      <NeuButton
        variant="primary" className="flex items-center gap-2" data-testid="payroll-announce"
        disabled={busy || locked} onClick={onAnnounce}
      >
        {locked ? <Lock className="h-4 w-4" /> : <Megaphone className="h-4 w-4" />}
        {t("payrollCycle.announce")}
      </NeuButton>
      {locked && cycle.opens_at ? (
        <p className="mt-2 text-xs text-muted-foreground" data-testid="payroll-announce-opens-at">
          {t("payrollCycle.opensAt", { date: cycle.opens_at })}
        </p>
      ) : null}
    </div>
  );
};
